// /Users/aminajackson/Git-projects/pro-maximizer/frontend/src/ThemeAwareMarkdown.tsx

import React from 'react';
import ReactMarkdown from 'react-markdown';
import {
  Typography,
  List,
  ListItem,
  Paper,
  Link as MuiLink,
} from '@mui/material';

// This object maps standard markdown elements to theme-aware Material-UI components.
// It's the single source of truth for all markdown styling.
const markdownComponents = {
  h1: (props: any) => <Typography variant="h1" color="text.primary" {...props} gutterBottom />,
  h2: (props: any) => <Typography variant="h2" color="text.primary" {...props} gutterBottom />,
  h3: (props: any) => <Typography variant="h3" color="text.primary" {...props} gutterBottom />,
  h4: (props: any) => <Typography variant="h4" color="text.primary" {...props} gutterBottom />,
  h5: (props: any) => <Typography variant="h5" color="text.primary" {...props} gutterBottom />,
  h6: (props: any) => <Typography variant="h6" color="text.primary" {...props} gutterBottom />,
  p: (props: any) => <Typography color="text.secondary" {...props} gutterBottom />,
  li: (props: any) => (
    <ListItem sx={{ display: 'list-item', py: 0.5, pl: 2 }}>
      <Typography component="span" color="text.primary" {...props} />
    </ListItem>
  ),
  ul: (props: any) => <List sx={{ listStyleType: 'disc', pl: 2 }} {...props} />,
  a: (props: any) => <MuiLink {...props} />,
  code: (props: any) => {
    const { inline, children } = props;
    if (inline) {
      return (
        <Typography
          component="code"
          sx={{
            bgcolor: 'action.hover',
            px: '4px',
            py: '2px',
            borderRadius: 1,
            fontFamily: 'monospace',
            color: 'text.primary',
          }}
        >
          {children}
        </Typography>
      );
    }
    return (
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          my: 2,
          bgcolor: 'action.hover',
          overflowX: 'auto',
          fontFamily: 'monospace',
          whiteSpace: 'pre-wrap',
        }}
      >
        <code>{children}</code>
      </Paper>
    );
  },
};

interface ThemeAwareMarkdownProps {
  children: string;
}

const ThemeAwareMarkdown: React.FC<ThemeAwareMarkdownProps> = ({ children }) => {
  return <ReactMarkdown components={markdownComponents}>{children}</ReactMarkdown>;
};

export default ThemeAwareMarkdown;